import { render, staticRenderFns } from "./FrontWheel.vue?vue&type=template&id=ee3ef6da"
import script from "./FrontWheel.vue?vue&type=script&lang=js"
export * from "./FrontWheel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports